export const LIBRARY_NAME = '@wallaby-ui/haidi';
export const APPLICATION_NAME_HAIDI = 'HAIDI';

export default {LIBRARY_NAME};
